import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const CarriageTerms = () => {
  const { t } = useTranslation();
  const pageTitle = t('carriageTerms.title', 'Terms of Carriage');
  const contentHtml = t('carriageTerms.contentHtml', '');

  return (
    <div className="min-h-screen">
      <section className="bg-white text-gray-900">
        <div className="container-custom">
          <motion.div
            initial={false}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="max-w-4xl mx-auto px-4 md:px-8 py-12"
          >
            <h1 className="text-3xl md:text-4xl font-bold mb-6">{pageTitle}</h1>
            <div className="prose prose-gray prose-lg max-w-none">
              <div
                className="leading-relaxed whitespace-pre-wrap"
                dangerouslySetInnerHTML={{ __html: contentHtml }}
              />
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default CarriageTerms;


